// services/courier.service.js
import API from "../app/api";

// Helper to extract error message
const getErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "Something went wrong";

const courierService = {
  checkPincode: async (pincode) => {
    try {
      const response = await API.post("/services/pincode", { pincode });
      return response.data?.data;
    } catch (error) {
      throw getErrorMessage(error); // always return clean message
    }
  },
};

export default courierService;